/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary as FeErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import SsrErrorBoundary from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';
import type { ErrorBoundaryProps } from './types.tsx';

export const ErrorBoundary = ({
	children,
	id,
	withExperienceTracker,
}: ErrorBoundaryProps): React.JSX.Element => {
	if (__SERVER__) {
		return <SsrErrorBoundary id={id}>{children}</SsrErrorBoundary>;
	}

	return (
		<FeErrorBoundary
			id={id}
			packageName="jiraEntry"
			fallback="page"
			withExperienceTracker={withExperienceTracker}
		>
			{children}
		</FeErrorBoundary>
	);
};
